import { useContext } from 'react';
import { EasyUploadLinkModalContext } from './EasyUploadLinkModalContext';
export default function useEasyUploadLinkModalContext() {
    const context = useContext(EasyUploadLinkModalContext);
    if (!context) {
        throw new Error('useEasyUploadLinkModalContext must be used within an EasyUploadLinkModalContextProvider');
    }
    return context;
}
